const Style = {

  base: 'relative block text-sg-red text-sm -mt-1 mb-4 py-2 px-3 bg-sg-red-bg rounded-b'

}

export default Style;